module.exports = __webpack_public_path__ + "img/stainGlass.81a2414d.png";